<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title
        >车辆温湿度动态明细
        <template slot="operate">
          <!-- <el-button
                                class="g-form-section-search operate__item"
                                icon="e6-icon-set-up_line"
                                type="primary"
                                title="表格列设置"
                                @click="columSetVisible = !columSetVisible"
                              ></el-button>
                              <el-button
                                class="g-form-section-search operate__item"
                                icon="e6-icon-export_line"
                                type="primary"
                                title="导出"
                                @click="handleExport"
                              ></el-button> -->
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            v-if="operationSuper.导出"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.timeRange">
            <el-date-picker
              v-model="slotForms.forms.timeRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.comparyName">
            <el-select
              v-model="slotForms.forms.comparyName"
              filterable
              clearable
              placeholder="企业名称"
              @change="InitTreeNode"
            >
              <el-option
                v-for="item in allComparys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="search-item" prop="forms.pointId">
            <e6-select
              ref="pointTree"
              :dataList="locationStoragePointList"
              :multiple="true"
              filterable
              issingleleaf
              slotTemplate="tree"
              widthData="200px"
              placeholder="车牌号"
              @multipleSelect="pointTreeChanged"
            ></e6-select>
            <!-- issingleleaf -->
            <!-- <el-select v-model="slotForms.forms.pointId" multiple  placeholder="仓库/区位/监测点">
                                      <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-select> -->
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 查询条件 end -->
    <section class="radio-wrapper fixed-section fixed-view">
      <el-row :gutter="24">
        <el-col :span="2" style="padding-right:0;">
          <el-radio-group v-model="chartOrList">
            <el-radio-button :label="0" title="图表">
              <i class="e6-icon-chart_fill1"></i
            ></el-radio-button>
            <el-radio-button :label="1" title="表格">
              <i class="e6-icon-table_fill"></i
            ></el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col
          :span="22"
          style="padding-left:0px"
          v-if="locationStorageData.length"
        >
          <!-- 监测点跑马灯  -->
          <point-carousel
            ref="myArousel"
            :isIntervalTime="isIntervalTime"
            :searchData="formExtend.forms"
            :locationStorageData="locationStorageData"
            @initData="FetchFindByPage"
          >
            <template v-slot="{ label }">
              <span :title="generateLabel(label)">
                {{ generateLabel(label) }}</span
              >
            </template>
          </point-carousel>
        </el-col>
      </el-row>
    </section>
    <section
      class="data-wrapper"
      :style="{ height: resizeViewHeight + 'px' }"
      v-loading="loadingMask"
      element-loading-text="数据正在加载中..."
    >
      <!-- 仓库温湿度动态明细图表 -->
      <section v-show="chartOrList === 0" class="chart-wrapper">
        <div v-show="isChart" class="chart-content">
          <div class="event-count">
            <div
              class="event-count-chart"
              :style="{
                height: resizeViewHeight + 'px',
                width: resizeViewWidth + 'px'
              }"
            ></div>
          </div>
        </div>
      </section>
      <!-- 仓库温湿度动态明细表格 -->
      <section
        v-show="chartOrList !== 0"
        class="data-wrapper"
        :style="{ height: resizeViewHeight + 'px' }"
      >
        <el-table
          :data="tableData"
          ref="vanguardSettingTable"
          height="100%"
          style="width: 100%"
          border
        >
          <el-table-column
            label="序号"
            type="index"
            align="center"
            fixed
            width="50"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in localShowTableCols"
            :key="index"
            fixed
            :show-overflow-tooltip="true"
            :prop="item.name"
            :label="item.title"
          ></el-table-column>
        </el-table>
      </section>
      <!-- 没有选择监测点 -->
      <div class="figure-data" style="top:-100%" v-show="isNoSelect">
        <div class="nodate">
          <img src="../../assets/images/pg-search.png" alt="" />
          <p style="color: #ccc;">请选择企业下的车辆并进行查询</p>
        </div>
      </div>
      <div class="figure-data" style="top:-100%" v-show="isNodata">
        <div class="nodate">
          <img src="../../assets/images/pg-nodata.png" alt="" />
          <p style="color: #bbb;">未查询到相关数据</p>
        </div>
      </div>
    </section>
    <!-- 表格数据分页 -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        v-show="chartOrList !== 0"
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <!-- <e6-column-set
              @setColumnSubmit="handleSetColumnSubmit"
              @setColumnCancel="handleSetColumnCancel"
              :columSetVisible.sync="columSetVisible"
              :hideTableCols.sync="copyHideTableCols"
              :showTableCols.sync="copyShowTableCols"
            ></e6-column-set> -->
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
// import {
//   FetchGetTableColumnSettings,
//   FetchSaveUserTableColumnSettings
// } from "_private/api/public.js";
import {
  FetchFindrefrigVelHumDetailByPage,
  FetchTreeNode,
  FetchFreezerChartData
} from "@/api/report/humDetail";
// import { exportXlsx } from "@/utils/exportXlsx.js";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import eCharts from "echarts";
import moment from "moment";
import { mergeFormExtend, cloneDeep } from "_private/utils/merge";
import { mapGetters, mapActions } from "vuex";
import storageMixin from "../../mixins/storage-mixin.js";
import { getBarLineOpt } from "../../assets/js/storageHumidityCharts.js";
import pointCarousel from "../../components/pointCarousel/index";
import { FetchAllComparys } from "_private/api/systemSetting/userManage";

export default {
  components: {
    pointCarousel
  },
  mixins: [resizeListener, storageMixin, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      columSetVisible: false,
      searchOpenValue: true, //是否收起查询条件
      loadingMask: false, // 加载遮罩
      pickerOptions: datePickerOptionsNotContainToday,
      locationStoragePointList: [], //仓库区位检测点数据集合
      pointIds: [], //监测点
      pPointId: this.$route.query.pPointId, //获取从仓库监控跳转过去的url参数
      allComparys: [],
      pointData: null,
      formExtend: {
        forms: {
          timeRange: [],
          comparyName: "",
          pointId: [],
          beginTime: "", //开始时间
          endTime: "" //结束时间
        },
        extends: []
      },
      pointId: "",
      //表格列设置
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [
        {
          fixable: true,
          name: "companyName",
          show: true,
          title: "所属企业"
        },
        {
          fixable: false,
          name: "vehicleName",
          show: true,
          title: "车辆"
        },
        {
          fixable: false,
          name: "labelName",
          show: true,
          title: "监测点名称"
        },
        {
          fixable: false,
          name: "gpsTime",
          show: true,
          title: "时间"
        },
        {
          fixable: false,
          name: "temperature",
          show: true,
          title: "温度（℃）"
        },
        {
          fixable: false,
          name: "humidity",
          show: true,
          title: "湿度（%RH）"
        },
        {
          fixable: false,
          name: "temperatureRequire",
          show: true,
          title: "温度要求"
        },
        {
          fixable: false,
          name: "humidityRequire",
          show: true,
          title: "湿度要求"
        }
      ],
      locationStorageData: [], //监测点数据
      columnSetVisible: false, // 动态列设置弹框
      columnList: [], // 动态列-列数据
      eChart: null, // eChart实例
      isNodata: false, //是否有数据
      isNoSelect: true, //是否选择了监测点
      isChart: true, //是否显示图表
      chartOrList: 0, // 图表与表格切换
      tableData: [], // 仓库温湿度明细表格数据
      chartData: [], // 仓库温湿度明细图表数据
      isFirst: true, //是否第一次加载监测点数据
      isIntervalTime: true, //验证时间间隔
      isTemperature: true, //验证基准温度
      isHumidity: true, //验证基准湿度
      //导出URL
      exportUrl: "/report/VehicleHumitureDynamic/exportVehicleHumitureDynamic?"
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"]),
    //获取页面宽度
    resizeViewWidth() {
      let w = 0;
      let hr = 20;
      return document.body.clientWidth - w - hr;
    }
  },
  created() {
    // 条件查询时间范围恢复默认值-昨天
    this.formExtend.forms.timeRange = [
      moment()
        .subtract(1, "day")
        .startOf("day")
        .toDate(),
      moment()
        .subtract(1, "day")
        .endOf("day")
        .toDate()
    ];
    // 获取表格列设置
    // this.FetchGetTableColumnSettings({
    //   moduleId: this.moduleId,
    //   userId: this.userId
    // });
    // 初始化企业树
    this.initAllComparys();
    //获取仓库/区位/监测点树形列表
    // this.storageLocationPointSetting();
    this.setSearchFormIsOpenAct();
  },
  watch: {
    "formExtend.forms.timeRange"(val) {
      this.formExtend.forms.beginTime = moment(val[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.formExtend.forms.endTime = moment(val[1]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    "formExtend.forms.comparyName"(val) {
      if (val == "") {
        this.$refs.pointTree.multipleRemoveAll();
        this.locationStoragePointList = [];
      }
    }
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 检验时间40天
    validataTime() {
      let start = moment(this.formExtend.forms.timeRange[0]);
      let end = moment(this.formExtend.forms.timeRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    initAllComparys() {
      FetchAllComparys()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.allComparys = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    InitTreeNode(val) {
      let params = {
        companyId: val,
        dataType: 3
      };
      this.$refs.pointTree.multipleRemoveAll();
      this.formExtend.forms.pointId = [];

      FetchTreeNode(params)
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.locationStoragePointList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 处理当前表格数据
    handleTableData() {
      let maxPage = Math.ceil(this.chartData.length / this.pageSize);
      maxPage = maxPage > 0 ? maxPage : 1;
      if (this.curPage > maxPage) {
        this.curPage = maxPage;
      } else if (this.curpage < 1) {
        this.curPage = 1;
      }
      let start = (this.curPage - 1) * this.pageSize;
      let partTable = this.chartData.slice(start, start + this.pageSize);
      return partTable.map(row => {
        return {
          companyName: this.pointData.comparyName,
          vehicleName: this.pointData.vehicleNum,
          labelName: this.pointData.labelName,
          humidityRequire: this.pointData.humidityRequire,
          temperatureRequire: this.pointData.temperatureRequire,
          ...this.handleRow(row)
        };
      });
    },
    handleRow(obj) {
      Object.keys(obj).forEach(key => {
        if (obj[key] == "-999") {
          obj[key] = "--";
        }
      });
      return obj;
    },
    // 获取echart数据
    async getChartsData(data) {
      try {
        this.loadingMask = true;
        let res = await FetchFreezerChartData(data);
        this.loadingMask = false;
        if (res && res.code === 1) {
          if (Array.isArray(res.result) && res.result.length > 0) {
            this.isNodata = false;
            // 生成图表
            this.chartData = res.result;
            //获取当前检测点的湿度和温度值

            this.pointData = this.getPointHandT();
            //加载图表信息
            this.loadChartData(this.chartData, this.pointData);

            this.total = this.chartData.length;
            this.curPage = 1;
            this.tableData = this.handleTableData();

            //初始化监测点的位置
            this.initPointPosition();
            return;
          }
        }
        this.total = 0;
        this.curPage = 1;
        this.tableData = [];
        this.isNodata = true;
      } catch (ex) {
        this.loadingMask = false;
        this.isNodata = true;
        console.log(ex);
      }
    },
    // 获取表格数据
    FetchFindByPage(id) {
      this.pointId = id;
      if (this.validataTime()) {
        this.getChartsData({
          labelId: id,
          beginTime: this.formExtend.forms.beginTime,
          endTime: this.formExtend.forms.endTime
        });
      }
    },
    // 获取表格列列表
    // FetchGetTableColumnSettings(data) {
    //   FetchGetTableColumnSettings(data)
    //     .then(response => {
    //       response = {
    //         code: 1,
    //         message: "OK",
    //         result: [
    //           {
    //             fixable: true,
    //             name: "comparyName",
    //             show: true,
    //             title: "所属企业"
    //           },
    //           {
    //             fixable: false,
    //             name: "alarmTotal",
    //             show: true,
    //             title: "仓库名称"
    //           },
    //           {
    //             fixable: false,
    //             name: "number",
    //             show: true,
    //             title: "区位名称"
    //           },
    //           {
    //             fixable: false,
    //             name: "number",
    //             show: true,
    //             title: "监测点名称"
    //           },
    //           {
    //             fixable: false,
    //             name: "number",
    //             show: true,
    //             title: "时间"
    //           },
    //           {
    //             fixable: false,
    //             name: "cangkuNumber",
    //             show: true,
    //             title: "温度（℃）"
    //           },
    //           {
    //             fixable: false,
    //             name: "mendianNumber",
    //             show: true,
    //             title: "湿度（%RH）"
    //           }
    //         ]
    //       };
    //       let data = response;
    //       let showTableCols = [];
    //       let hideTableCols = [];
    //       if (data && data.result && Array.isArray(data.result)) {
    //         data.result.forEach(item => {
    //           if (item.show) {
    //             showTableCols.push(item);
    //           } else {
    //             hideTableCols.push(item);
    //           }
    //         });
    //       }
    //       this.showTableCols = showTableCols;
    //       this.hideTableCols = hideTableCols;
    //       this.copyShowTableCols = showTableCols;
    //       this.copyHideTableCols = hideTableCols;
    //       this.localShowTableCols = showTableCols;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    // 修改表格列列表
    // FetchSaveUserTableColumnSettings(data) {
    //   FetchSaveUserTableColumnSettings(data)
    //     .then(response => {
    //       let type = response.code === 1 ? "success" : "error";
    //       let message = response.message;
    //       this.$message({
    //         showClose: true,
    //         message: message,
    //         type: type,
    //         duration: 2000,
    //         onClose: () => {
    //           if (type === "success") {
    //             this.FetchGetTableColumnSettings({
    //               moduleId: this.moduleId,
    //               userId: this.userId
    //             });
    //           }
    //         }
    //       });
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend));
    },
    // 生成监测点标题
    generateLabel(label) {
      return `${label.vehicleNum} - ${label.labelName}`;
    },
    // 仓库区位监测点下拉树选中项改变
    pointTreeChanged(nodes) {
      this.formExtend.forms.pointId = this.pointIds = nodes.map(
        node => node.id
      );
      //判断是否有勾选的监测点
      if (!this.pointIds.length) {
        this.formExtend.forms.pointId = [];
      }
    },
    formatSearchData(data) {
      let resultData = cloneDeep(data);
      delete resultData.comparyName;
      delete resultData.timeRange;
      resultData.labelIdList = resultData.pointId;
      delete resultData.pointId;
      // resultData.labelIdList = [12];
      return resultData;
    },
    formatVehicleID(arr) {
      return arr.map(item => {
        return {
          labelId: item.vehicleId,
          ...item
        };
      });
    },
    //仓库区位监测点名称&监测点报警设置
    async getStorageLocationPointNameList(data) {
      try {
        this.loadingMask = true;
        let searchData = this.formatSearchData(data);
        let res = await FetchFindrefrigVelHumDetailByPage(searchData);
        if (res && res.code == 1) {
          if (res.result && res.result.length > 0) {
            this.locationStorageData = this.formatVehicleID(res.result);
            // this.locationStorageData = res.result;
            this.pointId = this.locationStorageData[0].labelId;
            this.getChartsData({
              labelId: this.locationStorageData[0].labelId,
              beginTime: this.formExtend.forms.beginTime,
              endTime: this.formExtend.forms.endTime
            });
            return;
          }
        }
        this.loadingMask = false;
        this.isNodata = true;
        // let locationStorageData = [];
        // if (res.result) {
        //   if (res.result && Object.keys(res.result).length) {
        //     locationStorageData = res.result;
        //   }
        // }
        //保存数据
        // this.locationStorageData = locationStorageData;
        //获取监测点ID
        // if (this.isFirst) {
        //   this.formExtend.forms.pointId = this.formExtend.forms.pointId;
        // } else {
        //   // this.formExtend.forms.pointId= this.formExtend.forms.pointId[this.$refs.myArousel.idx];
        //   this.formExtend.forms.pointId = [...this.formExtend.forms.pointId];
        // }
        // this.isFirst = false;
        // // 查询数据
        // this.FetchFindByPage();
        return true;
      } catch (err) {
        this.loadingMask = false;
        console.log(err);
        throw new Error(err);
      }
    },
    //加载图表信息
    loadChartData(chartData, pointData) {
      this.$nextTick(() => {
        let dom = document.querySelector(".event-count-chart");
        this.eChart = eCharts.init(dom);
        this.eChart.setOption(getBarLineOpt(chartData, pointData));
      });
    },
    //初始化监测点的位置
    initPointPosition() {
      //先判断是否存在监测点组件
      if (this.$refs.myArousel) {
        let myArousel = this.$refs.myArousel;
        let data = myArousel.$refs.menu.children;
        //判断是否点击了查询按钮
        if (myArousel.isSearch) {
          for (let i = 0; i < data.length; i++) {
            data[i].style.left = i * myArousel.vLeft + "px";
          }
        }
      }
    },
    //初始化查询条件
    initSearchFactor() {
      this.isNoSelect = true;
      this.locationStorageData = [];
      this.tableData = [];
      this.isChart = false;
      this.isNodata = false;
      this.total = 0;
      this.curpage = 1;
    },
    //获取当前检测点的湿度和温度值
    getPointHandT() {
      let data = this.locationStorageData;
      let point = data.find(item => {
        return item.labelId == this.pointId;
      });
      return point;
    },
    //仓库区位监测点名称&监测点报警设置
    storageLocationPointSetting() {
      // let params = {
      //   pointIds: this.formExtend.forms.pointId
      // };
      this.getStorageLocationPointNameList(this.mergeObj());
    },
    // 导出
    handleExportClick() {
      let param = "";

      if (
        this.formExtend.forms.timeRange !== null &&
        this.formExtend.forms.timeRange !== ""
      ) {
        if (this.formExtend.forms.pointId.length) {
          param += "&beginTime=" + this.formExtend.forms.beginTime;
          param += "&endTime=" + this.formExtend.forms.endTime;
          param += "&labelId=" + this.pointId;
          document.location.href = this.exportUrl + param;
        } else {
          this.$message.warning("请选择车辆！");
        }
      } else {
        this.$message.warning("日期不能为空！");
      }
    },
    // 导出页面数据
    // handleExport() {
    //   let start = moment(this.formExtend.forms.timeRange[0]);
    //   let end = moment(this.formExtend.forms.timeRange[1]);
    //   //判断是否选择了监测点
    //   if (!this.pointIds.length) {
    //     //判断时间间隔不能大于40天
    //     if (end.diff(start, "days") > 39) {
    //       this.$message.error("开始时间与结束时间间隔不能大于40天！");
    //       return;
    //     }
    //     this.exportData();
    //   } else {
    //     this.$message.warning("请选择监测点并进行查询");
    //   }
    // },
    // 导出页面数据接口请求
    // async exportData(params) {
    //   try {
    //     exportListByStorage(params).then(res => {
    //       // 导出
    //       exportXlsx(res, `冷藏车温湿度动态明细.xls`);
    //     });
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.curPage = 1;
      this.tableData = this.handleTableData();
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.tableData = this.handleTableData();
    },
    // 查询数据
    handlesSubmitForm() {
      //判断是否选择了监测点
      if (this.formExtend.forms.pointId.length) {
        //验证时间
        if (!this.formExtend.forms.timeRange) {
          this.$message.error("请选择开始/结束时间！");
          return;
        }
        let start = moment(this.formExtend.forms.timeRange[0]);
        let end = moment(this.formExtend.forms.timeRange[1]);
        if (end.diff(start, "days") > 39) {
          this.$message.error("开始时间与结束时间间隔不能大于40天！");
          return;
        }
        //重置监测点的下标值
        if (this.$refs.myArousel) {
          this.$refs.myArousel.idx = 0;
          this.$refs.myArousel.isSearch = true;
        }
        this.isChart = true;
        //隐藏没有选择监测点提示
        this.isNoSelect = false;
        //仓库区位监测点名称&监测点报警设置
        this.storageLocationPointSetting();
      } else {
        this.$message.warning("请选择车辆并进行查询");
        //初始化查询条件
        this.initSearchFactor();
      }
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    }
    // 取消表格列设置
    // handleSetColumnCancel() {
    //   this.copyShowTableCols = this.showTableCols;
    //   this.copyHideTableCols = this.hideTableCols;
    // }
    // 确认表格列设置
    // handleSetColumnSubmit() {
    //   this.FetchSaveUserTableColumnSettings({
    //     moduleId: this.moduleId,
    //     userId: this.userId,
    //     columnStr: this.columnStr
    //   });
    // }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  height: 50px;
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.e6-tree-wrapper {
  position: relative;
  .e6-tree {
    position: absolute;
    left: 0;
    right: 0;
    background-color: #fff;
    border: 1px solid #ccc;
    /deep/ .el-input__inner {
      border: {
        radius: 0;
        width: 0 0 1px 0;
      }
    }
    .e6-tree__contontent {
      max-height: 300px;
      min-height: 56px;
      width: 100%;
      overflow: auto;
    }
    /deep/ .el-tree {
      width: fit-content;
    }
  }
}

.section-wrapper {
  /deep/ .el-table__empty-text {
    display: none;
  }
  .search-item {
    .el-tip {
      position: absolute;
      right: 5px;
      top: 0;
      color: #909399;
      font-size: 12px;
    }
    /deep/ .el-input-group--prepend {
      .el-input-group__prepend {
        padding: 0 10px;
      }
      input {
        width: 100px;
        padding: 0 30px 0 15px;
      }
    }
  }
}

.data-wrapper {
  box-sizing: border-box;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  overflow: hidden;
  position: relative;
}

.radio-wrapper {
  box-sizing: border-box;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-top: none;
  border-bottom: 1px solid #dddddd;
  .el-radio-group {
    /deep/ .el-radio-button {
      .el-radio-button__inner {
        padding: 10px 5px 5px 10px;
        border: none;
        box-shadow: none;
        i {
          color: #909399;
          font-size: 20px;
        }
      }
    }
    /deep/ .el-radio-button.is-active {
      .el-radio-button__inner {
        background-color: transparent;
        i {
          color: #46bfea;
        }
      }
    }
  }
}

.event-count,
.chart-wrapper,
.chart-content,
.event-count-chart {
  height: 100%;
  position: relative;
  width: 100%;
}

/deep/ .event-count-chart {
  div:first-child,
  canvas {
    height: 100% !important;
  }
}

/deep/ .el-carousel__container {
  overflow: hidden;
  .el-carousel__item--card {
    width: 15%;
  }
  .el-carousel__item {
    span {
      display: block;
      height: 100%;
      margin: 5px 0;
    }
  }
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}

.figure-data {
  height: 100%;
  position: relative;
  top: -100%;
  background: #fff;
  .nodate {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
}
</style>
